<template>
  <div class="agree">
    <svg
      class="icon"
      aria-hidden="true"
      @click="choose"
    >
      <use :xlink:href="iconType" />
    </svg>
    <div class="article">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'checked',
    event: 'click'
  },
  props: ['checked'],
  data() {
    return {
      choosed: this.checked,
      iconType: '#icon-weixuanzhong'
    };
  },
  watch: {
    checked(value) {
      this.choosed = value;
      this.choosed ? (this.iconType = '#icon-xuanzhong') : (this.iconType = '#icon-weixuanzhong');
    },
    immediate:true
  },
  // 回显订阅邮箱选中状态
  created(){
    this.choosed = this.checked 
    this.choosed ? (this.iconType = '#icon-xuanzhong') : (this.iconType = '#icon-weixuanzhong');
  },
  methods: {
    choose() {
      this.choosed = !this.choosed;
      this.$emit('click', this.choosed);
    }
  }
};
</script>
<style lang="scss" scoped>
.agree {
  cursor: pointer;
  text-align: left;
  display: flex;
  align-items: center;
  color: #333;
  .icon {
    margin-right: 7px;
  }
  .article {
    line-height: 18px;
    width: 91%;
  }
}
</style>
